import React from 'react'
import ScrollHousing from '../componets/ScrollHousing'

function HousesListScreen() {
    
  return (
    <div className="standard-page">
        <div className="container">HousesListScreen
            <ScrollHousing />
            <div className=""></div>
        </div>        
    </div>
  )
}

export default HousesListScreen